import React from "react";
import { Pressable, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { ShiftCardProps } from "./types";
import { useStatusConfig } from "./config";
import { StatusBar } from "./StatusBar";
import { ShiftHeader } from "./ShiftHeader";
import { PositionsSummary } from "./PositionsSummary";

export function ShiftCard({
  shift,
  status,
  positions = [],
  location,
  onPress,
  compact = false,
  visibleFields,
}: ShiftCardProps) {
  const { colors } = useTheme();
  const statusConfig = useStatusConfig();
  const config = status ? statusConfig[status] : null;

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed, hovered }: { pressed: boolean; hovered: boolean }) => [
        styles.card,
        {
          borderColor: config?.color || colors.border,
          backgroundColor: hovered ? colors.cardHover : colors.card,
          opacity: pressed ? 0.9 : 1,
          cursor: "pointer" as any,
        },
        compact && styles.cardCompact,
      ]}
    >
      {config && <StatusBar config={config} compact={compact} />}
      <ShiftHeader shift={shift} compact={compact} config={config} location={location} visibleFields={visibleFields} />
      <PositionsSummary positions={positions} visibleFields={visibleFields} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  card: {
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 4,
  },
  cardCompact: {
    borderRadius: 6,
  },
});
